import NewLogo from '../NewLogo';
import './styles.scss';

interface LoadingProps {
  show: boolean;
}

function Loading({show}: LoadingProps) {
  return show ? (
    <div className="loading" data-testid="loading">
      <NewLogo isLoading={show} />
    </div>
  ) : null;
}

export default Loading;
